import _ from "lodash/fp";
import fetch from "isomorphic-fetch";

export const query = ({success, failure}) =>
  (location, method = "GET", parameters = {}, meta = {}) =>
    async dispatch =>  {
      meta = _.merge(meta, parameters);

      const locationBase = /^https?:\/\//i.test(location) ? "" : window.location.origin;
      const url = new URL(location, locationBase);
      let modifiers = {};

      if (method === "GET") {
        for (let [key, value] of Object.entries(parameters)) {
          url.searchParams.append(key, value);
        }
      }
      else {
        modifiers = {
          method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(parameters)
        }
      }

      let errors = [];
      try {
        const response = await fetch(url, modifiers);

        try {
          const json = await response.json();

          if (response.ok) {
            dispatch(success(json, meta));
            return json;
          }
          else {
            errors.push(..._.values(json));
          }
        }
        catch (error) {
          errors.push([
            "The communication with the server failed and a list of errors couldn't be retrieved from the server.",
            `Server status: HTTP ${response.status} ${response.statusText}`,
            `Communication error: ${error.message}`
          ]);
        }
      }
      catch (error) {
        errors.push([error.toString()])
      }

      dispatch(failure(errors, meta));
      return null;
    };
